import { useEffect } from "react";
import {REACT_APP_FB_APP_ID} from "constants/schemas"
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    _fbq?: any;
  }
}

const loadFacebookPixel = () => {
    (function (f: any, b: any, e: string, v: string) {
        if (f.fbq) return;
        const n: any = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        f.fbq = n;
        f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = "2.0";
        n.queue = [];
        const t = b.createElement(e);
        t.async = true;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

      window.fbq?.("init", REACT_APP_FB_APP_ID);
      window.fbq?.("track", "PageView");
  };

  const useFacebookPixel = () => {
    useEffect(() => {

    // const hasVisited = sessionStorage.getItem("hasVisited");

    // if (hasVisited) {
      // Nếu đã reload, gọi Facebook Pixel
    //   const loadPixel = async () => {
        loadFacebookPixel();
    //   };

    //   loadPixel();
    // } else {
    //     sessionStorage.setItem("hasVisited", "true");
    // }
    }, []);
  };
  
  export default useFacebookPixel;
